<template>
  <bottom-area-links />
</template>

<script>
const BottomAreaLinks = defineAsyncComponent(() => import('@/components/BottomAreaLinks.vue'))
import { CACHE_COMMON_BOTTOM_LINK } from '@/utils/constants/serverCaching'
export default {
  name: CACHE_COMMON_BOTTOM_LINK.name,
  serverCacheKey() {
    return Math.floor(Date.now() / CACHE_COMMON_BOTTOM_LINK.time)
  },
  components: { BottomAreaLinks }
}
</script>
